import { ProductParameterType } from 'types/parameter';
import { twMergeCustom } from 'utils/twMerge';

type VariantParametersListProps = {
    parameters: ProductParameterType[];
    variantsFilter: ProductParameterType[];
};

export const VariantParametersList: FC<VariantParametersListProps> = ({ parameters, variantsFilter, className }) => {
    if (parameters.length === 0) {
        return null;
    }

    const uuidsFromVariantFilter: string[] = [];
    for (const filterItem of variantsFilter) {
        uuidsFromVariantFilter.push(filterItem.uuid);
    }

    const filteredParameters = parameters.filter((item) => uuidsFromVariantFilter.includes(item.uuid));

    return (
        <div
            className={twMergeCustom(
                'mb-2 mt-2 inline rounded-sm text-xs !leading-3 text-secondary no-underline transition',
                className,
            )}
        >
            {filteredParameters.map(({ name, values }, index) => (
                <span className="mb-0.5 mr-1 leading-4" key={index}>
                    {name}: {values[0].text}
                    {index !== filteredParameters.length - 1 && ','}
                </span>
            ))}
        </div>
    );
};
